export default "/images/BC-Step-2.png?d19d567aaf49ffc296fa84621d1bd169";